module.exports = __webpack_public_path__ + "img/9788994475219.e342826c.jpg";